import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

import PopoverComponent from '../../PopoverComponent';
import PopoverHeader from './PopoverHeader';
import PopoverFooter from './PopoverFooter';
import PopoverBody from './PopoverBody';
import getFilterPosition from '../helpers/getFilterPosition';

class Popover extends PopoverComponent {
    /**
     * Overriding "closePopover" function from PopoverComponent.
     * So when popover is closed, categories went back to default
     */
    closePopover = () => {
        this.setState({ expanded: false });
        this.props.resetCategories();
    }

    /**
     * Overriding "openPopover" function from PopoverComponent.
     * So we can calculate position of filter popover
     */
    openPopover = ({ currentTarget }) => {
        this.setState({
            expanded: true,
            position: getFilterPosition(currentTarget)
        });
    }

    applyFilter = () => {
        this.props.applyFilter();
        this.setState({ expanded: false });
    }

    render() {
        const { expanded, position } = this.state;
        const { categories, dispatch } = this.props;

        return (
            <div ref={(node) => { this.node = node; }}>
                <button
                    className="ui-btn ui-btn_tiertiary"
                    onClick={this.togglePopover}
                >
                    <Svg
                        iconName="filter"
                        size="Medium"
                        className="cmn-filter__btnIcon tableShowIcon"
                    />
                    Filter
                </button>
                {expanded &&
                    <div className={`ui-popover cmn-filter__popover pos_${position}`}>
                        <div className="cmn-filter__pointer ui-popoverPointer" />
                        <PopoverHeader
                            cancelFilter={this.closePopover}
                        />
                        <PopoverBody
                            categories={categories}
                            dispatch={dispatch}
                        />
                        <PopoverFooter
                            cancelFilter={this.closePopover}
                            applyFilter={this.applyFilter}
                        />
                    </div>
                }
            </div>
        );
    }
}

Popover.propTypes = {
    categories: PropTypes.shape({}),
    resetCategories: PropTypes.func.isRequired,
    applyFilter: PropTypes.func.isRequired,
};

export default Popover;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/Popover.jsx